import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { DownloadTooltipIconComponent } from '../icons/download-tooltip-icon/download-tooltip-icon.component';
import { SpinnerIconComponent } from '../icons/spinner-icon/spinner-icon.component';
import { CsvOption } from '../../../components/my-campaigns-screen/types';

@Component({
  selector: 'app-download-widget',
  templateUrl: './download-widget.component.html',
  styleUrl: './download-widget.component.scss',
  imports: [CommonModule, DownloadTooltipIconComponent, SpinnerIconComponent]
})
export class DownloadWidgetComponent {
  @Input() tooltipText: string = '';
  @Input() options: CsvOption[] = [];
  @Input() onDownloadClick!: (option: CsvOption) => Promise<void> | void;

  isLoading = false;
  showOptions = false;

  constructor(private elementRef: ElementRef) {}

  async handleClick(option: CsvOption): Promise<void> {
    this.isLoading = true;
    this.showOptions = false;
    await this.onDownloadClick(option);
    this.isLoading = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.showOptions = false;
    }
  }
}